var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneybag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money_61584 1",
    clipPath: "url(#clip0_1449_12680)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.4433 53.1412C45.1446 52.8141 44.7666 52.5694 44.376 52.3655C43.5255 51.922 42.5954 51.653 41.6719 51.4102V58.5664C43.1709 58.397 44.8918 57.853 45.6788 56.4536C46.0546 55.7851 46.1293 54.9638 45.9763 54.2197C45.8932 53.8165 45.7218 53.4464 45.4433 53.1412Z",
    fill: "url(#paint0_linear_1449_12680)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M45.6641 56.4665C45.667 56.4616 45.6686 56.4584 45.6718 56.4531C45.6692 56.4575 45.6666 56.4619 45.6641 56.4665Z",
    fill: "url(#paint1_linear_1449_12680)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.6396 41.7002C34.3819 42.0765 34.2202 42.504 34.1756 42.9584C34.131 43.4138 34.156 43.9203 34.329 44.349C34.4938 44.7574 34.8388 45.059 35.195 45.3018C35.5946 45.5737 36.0342 45.786 36.4818 45.966C36.8574 46.1171 37.2798 46.2617 37.7351 46.4014V39.9258C36.5848 40.1713 35.3279 40.6953 34.6396 41.7002Z",
    fill: "url(#paint2_linear_1449_12680)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M45.7014 56.4023C45.692 56.4191 45.6819 56.4366 45.6719 56.4551C45.6835 56.4336 45.6928 56.4178 45.7014 56.4023Z",
    fill: "url(#paint3_linear_1449_12680)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M44.1896 17.4067C50.2753 12.2944 54.3418 0.777038 51.8393 0.273296C48.5141 -0.396288 41.2934 2.53976 37.8034 3.05705C32.8533 3.65473 27.462 -2.31073 24.4358 1.01441C21.9753 3.71798 26.1998 13.55 32.8093 17.8333C13.0903 27.5248 -14.626 76.1773 33.7266 79.7074C100.631 84.5922 67.1294 26.8509 44.1896 17.4067ZM49.9353 55.7763C49.7296 57.6731 48.7244 59.3884 47.2218 60.5528C45.6353 61.7824 43.6454 62.3543 41.6682 62.5145V64.6103C41.6682 65.171 41.4233 65.7134 41.0035 66.0846C40.4266 66.5951 39.5787 66.721 38.8784 66.3984C38.187 66.0803 37.7328 65.3711 37.7328 64.6103V62.3197C37.3938 62.2553 37.0572 62.1787 36.7246 62.0874C34.8768 61.5797 33.1628 60.5901 31.9108 59.1259C31.2871 58.3961 30.7787 57.568 30.427 56.6741C30.3352 56.4405 30.2533 56.2025 30.1816 55.9619C30.1166 55.7441 30.0496 55.5228 30.0265 55.2957C29.9875 54.9149 30.063 54.5264 30.2405 54.1872C30.6053 53.4893 31.3741 53.0679 32.1591 53.1379C32.9316 53.2064 33.6087 53.7425 33.852 54.479C33.9269 54.7058 33.9777 54.9383 34.0618 55.1627C34.1452 55.3855 34.2459 55.6022 34.3644 55.8085C34.5982 56.2147 34.8911 56.5894 35.2284 56.9145C35.9238 57.5844 36.8095 58.0198 37.7328 58.2789V50.4927C35.9273 50.0253 34.0637 49.4216 32.5728 48.2624C31.8483 47.6988 31.2335 46.9985 30.8308 46.1697C30.406 45.2949 30.2299 44.3204 30.2228 43.3524C30.2155 42.3696 30.4022 41.3954 30.8122 40.4999C31.1962 39.6615 31.7491 38.9087 32.4269 38.2847C33.8764 36.9506 35.8018 36.2065 37.733 35.9331V35.7618V33.7576C37.733 33.197 37.9779 32.6545 38.3977 32.2833C38.9748 31.7729 39.8223 31.6468 40.5228 31.9695C41.214 32.2878 41.6684 32.9967 41.6684 33.7576V35.7618V35.9213C41.9257 35.9537 42.1823 35.9924 42.4376 36.0387C44.334 36.3819 46.1887 37.165 47.5755 38.5322C48.2325 39.1798 48.7703 39.9514 49.1485 40.7928C49.2541 41.0276 49.3465 41.2678 49.4265 41.5127C49.5011 41.741 49.576 41.9762 49.6116 42.2145C49.6684 42.5949 49.6104 42.988 49.4476 43.336C49.114 44.0491 48.366 44.5031 47.5789 44.4694C46.8056 44.4357 46.105 43.9322 45.828 43.2093C45.7456 42.9944 45.7044 42.7668 45.6202 42.5524C45.5353 42.3353 45.4254 42.1283 45.2987 41.9327C45.0525 41.5524 44.7334 41.2264 44.3692 40.9578C43.5804 40.3753 42.6238 40.0719 41.6679 39.9023V47.3533C42.8039 47.6254 43.9409 47.922 45.0293 48.3512C46.6744 48.9999 48.2332 49.9946 49.1312 51.563C48.9919 51.3187 48.8563 51.0806 49.1359 51.5711C49.4103 52.0531 49.2793 51.8234 49.1415 51.5819C49.8559 52.8409 50.0906 54.3462 49.9353 55.7763Z",
    fill: "url(#paint4_linear_1449_12680)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M45.6466 56.5039C45.6351 56.5244 45.6251 56.5425 45.6172 56.5562C45.624 56.5444 45.6341 56.5265 45.6466 56.5039Z",
    fill: "url(#paint5_linear_1449_12680)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1449_12680",
    x1: 43.8613,
    y1: 51.4102,
    x2: 43.8613,
    y2: 58.5664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61156,
    stopColor: "#FF7C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1449_12680",
    x1: 45.6679,
    y1: 56.4531,
    x2: 45.6679,
    y2: 56.4665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61156,
    stopColor: "#FF7C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1449_12680",
    x1: 35.9457,
    y1: 39.9258,
    x2: 35.9457,
    y2: 46.4014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61156,
    stopColor: "#FF7C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1449_12680",
    x1: 45.6867,
    y1: 56.4023,
    x2: 45.6867,
    y2: 56.4551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61156,
    stopColor: "#FF7C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1449_12680",
    x1: 39.9987,
    y1: 0,
    x2: 39.9987,
    y2: 80.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61156,
    stopColor: "#FF7C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1449_12680",
    x1: 45.6319,
    y1: 56.5039,
    x2: 45.6319,
    y2: 56.5562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61156,
    stopColor: "#FF7C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1449_12680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneybag);
export default __webpack_public_path__ + "static/media/moneybag.299ee6b7ad9c4b60a90067ee45a05db0.svg";
export { ForwardRef as ReactComponent };